import {RoomBaseApiService} from "./room.baseapi.service";
import {ErrorWrapper, ResponseWrapper} from "@/core/service/util";

export class RoomMediaService extends RoomBaseApiService {
    async getRoomMediaInfo (roomGroupId) {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/media?roomGroupId=${roomGroupId||''}`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async getRoomMediaInfoList () {
        try {
            const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/medias`)
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }


    async uploadRoomMediaFile ({roomGroupId='default', filename, file, onUploadProgress}) {
        try {
            const data = new FormData();
            data.append('roomGroupId', roomGroupId);
            data.append('filename', filename);
            data.append('file', file);
            data.append('duration', file.duration);

            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/media/files/add`, data, {
                onUploadProgress
            })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async removeRoomMediaFile ({roomGroupId, mediaId}) {
        const response = await this.request()
            .delete(`/api/v3/room/${this.getRoomId()}/media/${mediaId}?roomGroupId=${roomGroupId}`);
        return new ResponseWrapper(response, response.data.data)
    }

    async changeRoomMedia ({roomGroupId, mediaId}) {
        const response = await this.request()
            .post(`/api/v3/room/${this.getRoomId()}/media/change`, {roomGroupId, mediaId});
        return new ResponseWrapper(response, response.data.data)
    }

    async playRoomMedia({roomGroupId, mediaId, seekTime}) {
        const response = await this.request()
            .post(`/api/v3/room/${this.getRoomId()}/media/play`, {roomGroupId, mediaId, seekTime});
        return new ResponseWrapper(response, response.data.data)
    }

    async pauseRoomMedia({roomGroupId, seekTime, autoPause}) {
        const response = await this.request()
            .post(`/api/v3/room/${this.getRoomId()}/media/pause`, {roomGroupId, seekTime, autoPause});
        return new ResponseWrapper(response, response.data.data)
    }
    async createRoomMediaDownloadUrl({mediaId}) {
        const response = await this.request()
            .get(`/api/v3/room/${this.getRoomId()}/media/${mediaId}/createDownloadUrl`);
        return new ResponseWrapper(response, response.data.data)
    }
    async changeRoomMediaPlayType({roomGroupId, playType}) {
        const response = await this.request()
            .post(`/api/v3/room/${this.getRoomId()}/media/playType`, {roomGroupId, playType});
        return new ResponseWrapper(response, response.data.data)
    }
    async generateUploadPresignedUrl() {
        const response = await this.request()
            .post(`/api/v3/room/${this.getRoomId()}/media/presignedUrl/upload`);
        return new ResponseWrapper(response, response.data.data)
    }
    async completePresignedUrl(data) {
        const response = await this.request()
            .post(`/api/v3/room/${this.getRoomId()}/media/presignedUrl/complete`, data);
        return new ResponseWrapper(response, response.data.data)
    }
}

export const roomMediaService = new RoomMediaService()